export const REGISTER_TYPES = [
  "sighting",
  "capture",
  "feces",
  "tracks",
  "nest_or_burrow",
  "vocalization",
  "carcass",
  "camera_trap",
  "other",
] as const;

export const REGISTER_ENVIRONMENTS = [
  "cerrado",
  "gallery_forest",
  "shale",
  "vereda",
  "other",
] as const;

export const REGISTER_TYPE_COLORS: Record<
  RegisterType,
  { hex: string; tw: string }
> = {
  sighting: { hex: "#4ADE80", tw: "bg-green-400" },
  capture: { hex: "#60A5FA", tw: "bg-blue-400" },
  feces: { hex: "#CA8A04", tw: "bg-yellow-600" },
  tracks: { hex: "#F97316", tw: "bg-orange-500" },
  nest_or_burrow: { hex: "#F59E0B", tw: "bg-amber-500" },
  vocalization: { hex: "#A855F7", tw: "bg-purple-400" },
  carcass: { hex: "#EF4444", tw: "bg-red-500" },
  camera_trap: { hex: "#6B7280", tw: "bg-gray-500" },
  other: { hex: "#94A3B8", tw: "bg-slate-400" },
};

export type RegisterType = (typeof REGISTER_TYPES)[number];
export type RegisterEnvironment = (typeof REGISTER_ENVIRONMENTS)[number];

export const REGISTER_TYPE_LABELS: Record<RegisterType, string> = {
  sighting: "Avistamento",
  capture: "Captura",
  feces: "Fezes",
  tracks: "Rastros/Pegadas",
  nest_or_burrow: "Ninhos/Tocas",
  vocalization: "Vocalização",
  carcass: "Carcaça",
  camera_trap: "Armadilha Fotográfica",
  other: "Outros",
};

export const REGISTER_ENVIRONMENT_LABELS: Record<RegisterEnvironment, string> =
  {
    cerrado: "Cerrado",
    gallery_forest: "Mata de Galeria",
    shale: "Folhelho",
    vereda: "Vereda",
    other: "Outros",
  };

export const REGISTER_TYPE_OPTIONS = Object.entries(REGISTER_TYPE_LABELS).map(
  ([value, label]) => ({ value: value as RegisterType, label }),
);

export const REGISTER_ENVIRONMENT_OPTIONS = Object.entries(
  REGISTER_ENVIRONMENT_LABELS,
).map(([value, label]) => ({ value: value as RegisterEnvironment, label }));

export function getEnvironmentLabel(environment: RegisterEnvironment): string {
  return (
    REGISTER_ENVIRONMENT_LABELS[environment as RegisterEnvironment] ??
    environment
  );
}

export function getTypeLabel(type: RegisterType): string {
  return REGISTER_TYPE_LABELS[type as RegisterType] ?? type;
}
